// set form fields back to initial state
export function clearFields(setNewEventEnd, setNewEventStart, setNewEventLocation, setNewEventName, setAllDayCheckbox) {
  setNewEventStart('0900')
  setNewEventEnd('0930')
  setNewEventLocation('')
  setNewEventName('')
  setAllDayCheckbox(0)
}

// My function for correctly placing the events inside the grid. Created to solve the "indefinite span" problem of CSS Grid. Go to "Calendar.js" for more info.
export function populateBuckets(sortedArray, arrayAlldayEvents, arrayOnlyEventInItsHourSlot, mapPlacing, memoryEvents, lastEnd) {
  for (let i = 0; i < sortedArray.length; i++) {
    let currentEvent = sortedArray[i]
    if (currentEvent.allday) {
      arrayAlldayEvents.push(currentEvent)
    } else if (memoryEvents.length === 0) {
      memoryEvents.push(currentEvent)
      lastEnd = memoryEvents[0].end
    } else if (currentEvent.start >= lastEnd && memoryEvents.length === 1) {
      arrayOnlyEventInItsHourSlot.push(memoryEvents.pop())
      memoryEvents.push(currentEvent)
      lastEnd = memoryEvents[0].end;
    } else if (currentEvent.start >= lastEnd) {
      if (!mapPlacing[memoryEvents.length]) mapPlacing[memoryEvents.length] = []
      mapPlacing[memoryEvents.length].push([...memoryEvents.splice(0)])
      memoryEvents.push(currentEvent)
      lastEnd = memoryEvents[0].end;
    } else if (currentEvent.start < lastEnd) {
      memoryEvents.push(currentEvent)
      lastEnd = Math.max(currentEvent.end, lastEnd)
    }
  }
  if (!mapPlacing[memoryEvents.length]) mapPlacing[memoryEvents.length] = []
  mapPlacing[memoryEvents.length].push([...memoryEvents.splice(0)])
}

// START and END dates inside the event-object must be specified as the keys of the timeConvert object. Go to "App.js" for more info.
export const timeConvert = {
  '0000': '12:00AM -',
  '0030': '12:30AM -',
  '0100': '1:00AM -',
  '0130': '1:30AM -',
  '0200': '2:00AM -',
  '0230': '2:30AM -',
  '0300': '3:00AM -',
  '0330': '3:30AM -',
  '0400': '4:00AM -',
  '0430': '4:30AM -',
  '0500': '5:00AM -',
  '0530': '5:30AM -',
  '0600': '6:00AM -',
  '0630': '6:30AM -',
  '0700': '7:00AM -',
  '0730': '7:30AM -',
  '0800': '8:00AM -',
  '0830': '8:30AM -',
  '0900': '9:00AM -',
  '0930': '9:30AM -',
  '1000': '10:00AM -',
  '1030': '10:30AM -',
  '1100': '11:00AM -',
  '1130': '11:30AM -',
  '1200': '12:00PM -',
  '1230': '12:30PM -',
  '1300': '1:00PM -',
  '1330': '1:30PM -',
  '1400': '2:00PM -',
  '1430': '2:30PM -',
  '1500': '3:00PM -',
  '1530': '3:30PM -',
  '1600': '4:00PM -',
  '1630': '4:30PM -',
  '1700': '5:00PM -',
  '1730': '5:30PM -',
  '1800': '6:00PM -',
  '1830': '6:30PM -',
  '1900': '7:00PM -',
  '1930': '7:30PM -',
  '2000': '8:00PM -',
  '2030': '8:30PM -',
  '2100': '9:00PM -',
  '2130': '9:30PM -',
  '2200': '10:00PM -',
  '2230': '10:30PM -',
  '2300': '11:00PM -',
  '2330': '11:30PM -',
  '2400': '12:00AM -',
}